import { AuditEntity, ISyncable } from "@app/common";
import { Address, SyncApi, SyncSchedule, TotalPrice } from "@app/core";
import { Customer, CustomerConnection } from "@app/customers-base";
import { PhoneBookEntry } from "@app/orders-base";
import { Column, Display, Table } from "@messaia/cdk";
import { OrderItemBundle } from "./order-item-bundle";
import { VoiceOption } from "./voice-option";

@Table({
    endpoint: 'order',
    includes: ['Client', 'Customer', 'CustomerConnection'],
    // deletable: false
})
export class Order extends AuditEntity implements ISyncable {
    @Column({ filterOperator: '~', width: 90 })
    @Display($localize`:@@number:Number`)
    number: number;

    @Column({ name: 'customer.firstName', filter: 'customer.firstName', showGtSm: true })
    @Display($localize`:@@firstName:First name`)
    private firstName: string;

    @Column({ name: 'customer.lastName', filter: 'customer.lastName' })
    @Display($localize`:@@lastName:Last name`)
    private lastName: string;

    @Column({ name: 'customerConnection.address.address1', filter: 'customerConnection.address.address1', showGtLg: true })
    @Display($localize`:@@address1:Address 1`)
    private address1: string;

    @Column({ name: 'customerConnection.address.address2', filter: 'customerConnection.address.address2', width: 60, showGtLg: true })
    @Display($localize`:@@address2:Address 2`)
    private address2: string;

    @Column({ name: 'customerConnection.address.address3', filter: 'customerConnection.address.address3', width: 110, showGtLg: true })
    @Display($localize`:@@address3:Address 3`)
    private address3: string;

    @Column({
        name: 'customer.billingAddress.address1',
        filter: 'customer.billingAddress.address1',
        content: (row: Order) => `
            <div>${row.customer?.billingAddress?.address1} ${row.customer?.billingAddress?.address2}</div>
            <div>${row.customer?.billingAddress?.postalCode} ${row.customer?.billingAddress?.city}</div>`,
        showGtXl: true
    })
    @Display($localize`:@@billingAddress:Billing address`)
    private billingAddress: Address;

    customerId: number;
    customer: Customer;

    @Column({ showGtMd: true })
    @Display($localize`:@@tariffName:Tariff name`)
    tariffName: string;
    tariffId: number;

    // @Column({ name: 'client.name', endpoint: 'client?enabled=true&projection=id,name', maxWidth: 200, showGtXl: true })
    @Display($localize`:@@client:Client`)
    clientId: number;

    phoneNumberPortability: boolean = true;
    customerConnectionId: number;
    customerConnection: CustomerConnection;
    bundles: OrderItemBundle[];
    optionalBundles: OrderItemBundle[] = [];
    voIP: boolean;
    voiceOption: VoiceOption = new VoiceOption();
    phoneBookEntrySpecified: boolean;
    phoneBookEntries: PhoneBookEntry[];
    preferredDate: Date;
    preferredDateNotice: string;
    subscriptionDate: Date;
    oneOffTotal: TotalPrice = new TotalPrice();
    regularMonthlyTotal: TotalPrice = new TotalPrice();
    reducedMonthlyTotal: TotalPrice = new TotalPrice();
    shippingCostTotal: TotalPrice = new TotalPrice();
    syncSchedules: SyncSchedule[];
    syncScheduleDate: Date;
    cancellable: boolean;
    deletable: boolean;
    cancelled: boolean;
    terminable: boolean;
    terminationRevocable: boolean;
    syncApi: SyncApi;
}